<template>
	<span class="icon" :class="requirementClassObject">
				<span class="icon-list__label" v-html="$present('requirementName', requirement)"></span>
				<span class="icon" :class="completeClassObject" v-if="data.complete">Complete</span>
			</span>
	<!--	<div>-->
	<!--		<template v-if="!$slots.default">-->
	<!--			<span class="icon" :class="requirementClassObject">-->
	<!--				<span class="icon-list__label" v-html="$present('requirementName', requirement)"></span>-->
	<!--				<span class="icon" :class="completeClassObject" v-if="data.complete">Complete</span>-->
	<!--			</span>-->
	<!--		</template>-->
	<!--		<template v-else>-->
	<!--			<v-popover offset="8" placement="top" trigger="hover" id="pop">-->
	<!--				<span class="icon" :class="requirementClassObject">-->
	<!--					<span class="icon-list__label" v-html="$present('requirementName', requirement)"></span>-->
	<!--					<span class="icon" :class="completeClassObject" v-if="data.complete">Complete</span>-->
	<!--				</span>-->
	<!--				<template slot="popover">-->
	<!--					<slot/>-->
	<!--				</template>-->
	<!--			</v-popover>-->
	<!--		</template>-->
	<!--	</div>-->
</template>
<script>
export default {
	props: {
		requirement: {
			required: true,
			type: String,
		},
		data: {
			required: true,
			type: Object,
		},
	},

	computed: {
		requirementClassObject() {
			return {
				"icon--search": "fact_find" === this.requirement,
				"icon--card": "payment" === this.requirement,
				"icon--calendar": "appointment" === this.requirement,
				complete: this.data.complete,
			};
		},
		completeClassObject() {
			return {
				"icon--tick": true,
			};
		},
	}
};
</script>
